var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");
Object.defineProperty(exports, Symbol.toStringTag, {
  value: 'Module'
});
var spanUtils = require('../utils/spanUtils.js');
var propagationContext = require('../utils-hoist/propagationContext.js');

/**
 * A Sentry Span that is non-recording, meaning it will not be sent to Sentry.
 */
var SentryNonRecordingSpan = /*#__PURE__*/function () {
  "use strict";

  function SentryNonRecordingSpan() {
    var spanContext = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, SentryNonRecordingSpan);
    this._traceId = spanContext.traceId || propagationContext.generateTraceId();
    this._spanId = spanContext.spanId || propagationContext.generateSpanId();
  }

  /** @inheritdoc */
  return _createClass(SentryNonRecordingSpan, [{
    key: "spanContext",
    value: function spanContext() {
      return {
        spanId: this._spanId,
        traceId: this._traceId,
        traceFlags: spanUtils.TRACE_FLAG_NONE
      };
    }

    /** @inheritdoc */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
  }, {
    key: "end",
    value: function end(_timestamp) {}

    /** @inheritdoc */
  }, {
    key: "setAttribute",
    value: function setAttribute(_key, _value) {
      return this;
    }

    /** @inheritdoc */
  }, {
    key: "setAttributes",
    value: function setAttributes(_values) {
      return this;
    }

    /** @inheritdoc */
  }, {
    key: "setStatus",
    value: function setStatus(_status) {
      return this;
    }

    /** @inheritdoc */
  }, {
    key: "updateName",
    value: function updateName(_name) {
      return this;
    }

    /** @inheritdoc */
  }, {
    key: "isRecording",
    value: function isRecording() {
      return false;
    }

    /** @inheritdoc */
  }, {
    key: "addEvent",
    value: function addEvent(_name, _attributesOrStartTime, _startTime) {
      return this;
    }

    /** @inheritDoc */
  }, {
    key: "addLink",
    value: function addLink(_link) {
      return this;
    }

    /** @inheritDoc */
  }, {
    key: "addLinks",
    value: function addLinks(_links) {
      return this;
    }

    /**
     * This should generally not be used,
     * but we need it for being compliant with the OTEL Span interface.
     *
     * @hidden
     * @internal
     */
  }, {
    key: "recordException",
    value: function recordException(_exception, _time) {
      // noop
    }
  }]);
}();
exports.SentryNonRecordingSpan = SentryNonRecordingSpan;